<ng-container *transloco="let t">
  <main
    class="view-product-detail"
    [class.rtl]="rtlMode$ | async"
    [class.single-header]="(biggerThan$ | async)?.mobileL">
    <!-- Actual Product Page -->
    <div class="main-scroll" id="mainAppScroll" cdk-scrollable>
      @if ((biggerThan$ | async)?.xs) {
        <app-navigation-bar />
      }

      <div class="content">
        <div class="content-wrapper">
          <!-- Product Not Found -->
          @if (!product() && !(productLoading$ | async)) {
            <div class="no-results">
              <div class="message">
                <span class="fixed-space-32" aria-hidden="true"></span>
                <span>{{ t('msg_listing_not_found') }}</span>
                <span class="fixed-space-32" aria-hidden="true"></span>
                <a
                  class="popsy-button-primary"
                  [routerLink]="homeUrlFragment$ | async"
                  [queryParams]="queryParamsToKeep$ | async"
                  >{{ t('action_back_to_home') }}</a
                >
              </div>
            </div>
          }

          <!-- Product Loading -->
          @if (!product() && (productLoading$ | async)) {
            <app-featured-listing-card
              class="full-width"
              [product]="null"></app-featured-listing-card>
          }
          <!-- Product Container -->
          @if (product(); as product) {
            <div
              class="product-container"
              itemscope
              itemprop="mainEntityOfPage"
              itemtype="https://schema.org/WebPage"
              [attr.itemid]="permanentLink">
              <div
                class="basic-info flex flex-col p-0 br-0 premium-user"
                [class.m-0]="(lessThan$ | async)?.sm === true">
                @if (testProductPage() !== 'ppVar1' && testProductPage() !== 'ppVar2') {
                  <app-featured-listing-card
                    [product]="product"></app-featured-listing-card>
                }
                @if (testProductPage() === 'ppVar1' || testProductPage() === 'ppVar2') {
                  <app-variant-product-card
                    [variant]="testProductPage()"
                    [product]="product"></app-variant-product-card>
                }
              </div>
            </div>
          }

          <span class="fixed-space-64" aria-hidden="true"></span>
        </div>

        <app-footer
          class="footer"
          [class.phone]="(lessThan$ | async)?.mobileXL"></app-footer>
      </div>

      <!-- STICKY BUY BUTTONS MOBILE-->
      @if (!(biggerThan$ | async)?.sm) {
        <section class="sticky-bar">
          <div class="flex flex-col">
            <span>{{ t('label_estimated_price_total') }}</span>
            <strong>{{ totalPrice() | amount }}</strong>
          </div>
          <app-featured-buy-buttons
            [product]="product()"
            [showBuyNow]="true"></app-featured-buy-buttons>
        </section>
      }
    </div>
  </main>
</ng-container>
